import { IWlbServiceData } from "../common/models/white-label-service.model";

export const WhitelabelingData: IWlbServiceData = {
  enabled: true,
  logo: "images/svg/main_logo.svg",
  dashboard_logo: "images/svg/main_logo_wt.svg",
  favicon: "images/svg/logo_icon.svg",
  loginbackgroundimg: "images/svg/login_left_bg.svg",
  primary_color: "#5734B5",
  secondary_color: "#08003c",
  buttons_type: "rounded",
  formcontrol_type: "rounded",
  product_name: "Live Agent",
  company_name: "Nuacem AI",
  website: "https://www.nuacem.com",
  terms_url: "https://www.nuacem.com/terms",
  poweredbyimg: "images/svg/main_logo.svg",
};
